// basic options for all sliders
let defaults = {
    slidesPerView: 1,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
};
// call init function
initSwipers(defaults);
initSwipersBis(defaults);


// Slider classique

function initSwipers(defaults = {}, selector = ".swiper-anchor, .swiper-text-img, .swiper-actualite") {
    let swipers = document.querySelectorAll(selector);
    swipers.forEach((swiper) => {
        // get options
        let optionsData = swiper.dataset.swiper
            ? JSON.parse(swiper.dataset.swiper)
            : {
                navigation: {
                    nextEl: swiper.querySelector(".swiper-button-next"),
                    prevEl: swiper.querySelector(".swiper-button-prev"),
                    clickable: true,
                },
            };
        // combine defaults and custom options
        let options = {
            ...defaults,
            ...optionsData,
            navigation: {
                nextEl: swiper.querySelector(".swiper-button-next"),
                prevEl: swiper.querySelector(".swiper-button-prev"),
                clickable: true,
            },
            on: {
                click: function (event) {
                    const swiperButtonPrev = event.el.querySelector('.swiper-button-prev');
                    const swiperButtonNext = event.el.querySelector('.swiper-button-next');
                    const clicEvent = new Event('click');
                    var clickX = event.touches.currentX;
                    var halfWindowWidth = window.innerWidth / 2;
                    if (clickX < halfWindowWidth) {
                        swiperButtonPrev.dispatchEvent(clicEvent);
                    } else {
                        swiperButtonNext.dispatchEvent(clicEvent);
                    }
                }
            }
        };
        //console.log(options);
        // init
        new Swiper(swiper, options);

        if (swiper.querySelectorAll(".swiper-slide").length == 1) {
            swiper.classList.add("delete-nav");
        }
    });
}

var swiperLeft = new Swiper('.swiper-left', {
    slidesPerView: 1,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    }
});

var swiperRight = new Swiper('.swiper-right', {
    slidesPerView: 1,
    controller: {
        control: swiperLeft
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        clickable: true,
    },
});

swiperLeft.controller.control = swiperRight;


function initSwipersBis(defaults = {}, selector = ".swiper-mots-vignerons, .swiper-recettes") {
    let swipers = document.querySelectorAll(selector);
    swipers.forEach((swiper) => {
        // get options
        let optionsData = swiper.dataset.swiper
            ? JSON.parse(swiper.dataset.swiper)
            : {
                navigation: {
                    nextEl: swiper.querySelector(".swiper-button-next"),
                    prevEl: swiper.querySelector(".swiper-button-prev"),
                    clickable: true,
                },
            };
        // combine defaults and custom options
        let options = {
            ...defaults,
            ...optionsData,
            slideToClickedSlide: true,
            navigation: {
                nextEl: swiper.querySelector(".swiper-button-next"),
                prevEl: swiper.querySelector(".swiper-button-prev"),
                clickable: true,
            },
            on: {
                init: function () {
                    this.slideTo(2);
                }
            }
        };
        // init
        new Swiper(swiper, options);

        if (swiper.querySelectorAll(".swiper-slide").length == 1) {
            swiper.classList.add("delete-nav");
        }
    });
}

// Slider vigneron


var players = [];
var videoExist = 0;

function initSwipers2() {
    var galleryThumbs = new Swiper(".swiper-vigneron-thumb", {
        loop: false,
        centeredSlides: true,
        slidesPerView: 1.65,
        spaceBetween: 20,
        speed: 800,
        observer: true,
        updateOnWindowResize: true,
        observeSlideChildren: true,
        observeParents: true,
        allowTouchMove: true,
        slideToClickedSlide: true,
        pagination: {
            el: ".gutenberg-vigneron .swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".gutenberg-vigneron .swiper-button-next",
            prevEl: ".gutenberg-vigneron .swiper-button-prev",
            clickable: true,
        },
        breakpoints: {
            // when window width is <= 499px
            1025: {
                slidesPerView: 5,
                slidesPerGroup: 1,
                centeredSlides: true,
                spaceBetween: 60,
                slideToClickedSlide: true,
                loop: false
            },
        },
        on: {
            init: function (galleryThumbs) {
                let current_photo = this.slides[0].dataset.photo;
                let current_desc = this.slides[0].dataset.description;
                let current_nom = this.slides[0].dataset.nom;
                let current_localisation = this.slides[0].dataset.localisation;
                let current_vin = this.slides[0].dataset.vin;
                let current_ab = this.slides[0].dataset.ab;
                let current_hve = this.slides[0].dataset.hve;
                let current_film = this.slides[0].dataset.film;
                let current_video = this.slides[0].dataset.video;


                // Desktop
                if (window.innerWidth > 1025) {
                    if (current_video) {
                        videoExist = 1;
                        var player = new Vimeo.Player('myPlayer', {
                            id: current_video,
                            controls: false,
                            autoplay: false
                        });
                        document.querySelector('.vigneron-photo').classList.add('inactive');
                        document.querySelector('.myPlayer').classList.remove('inactive');
                        document.getElementById('playButton').addEventListener('click', function () {
                            document.querySelector('#playButton').classList.remove('active');
                            // Démarrer la lecture lorsque le bouton est cliqué
                            player.play().then(function () {

                            }).catch(function (error) {
                                console.error('Erreur lors du démarrage de la vidéo :', error);
                            });
                        });
                        document.querySelector('#playButton').classList.add('active');

                        player.on('ended', function () {
                            // Revenir au début de la vidéo
                            player.setCurrentTime(0);
                            document.querySelector('#playButton').classList.add('active');
                        });
                    }
                }

                // Mobile

                if (window.innerWidth < 1025) {
                    if (current_video) {
                        var player = new Vimeo.Player(current_film, {
                            id: current_video,
                            controls: false,
                            autoplay: false
                        });
                        players.push(player);
                        document.getElementById('playButtonMobile').addEventListener('click', function () {
                            // Démarrer la lecture lorsque le bouton est cliqué
                            document.querySelector('#playButtonMobile').classList.remove('active');
                            player.play().then(function () {

                            }).catch(function (error) {
                                console.error('Erreur lors du démarrage de la vidéo :', error);
                            });

                            player.on('ended', function () {
                                // Revenir au début de la vidéo
                                player.setCurrentTime(0);
                                document.querySelector('#playButtonMobile').classList.add('active');
                            });

                        });
                        document.querySelector('#playButtonMobile').classList.add('active');
                    }
                }


                document.querySelector('.vigneron-description-text').textContent = current_desc;
                document.querySelector('.vigneron-photo').src = current_photo;
                document.querySelector('.vigneron-nom').textContent = current_nom;
                document.querySelector('.vigneron-localisation').textContent = current_localisation;
                document.querySelector('.vigneron-vin').textContent = current_vin;

                var descriptionDiv = document.querySelector('.vigneron-certifs');

                if (current_ab == 1) {
                    var imageElement = new Image();
                    imageElement.src = '/wp-content/themes/moutoncadet/assets/img/ab.png';
                    imageElement.alt = 'Agriculture biologique';
                    descriptionDiv.appendChild(imageElement);
                }
                if (current_hve == 1) {
                    var imageElement = new Image();
                    imageElement.src = '/wp-content/themes/moutoncadet/assets/img/hve.png';
                    imageElement.alt = 'HVE';
                    descriptionDiv.appendChild(imageElement);
                }
            },
            realIndexChange: function () {
                let index = this.realIndex; /* slide 1 => slides[1] */
                let current_data = this.slides[index].dataset.description;
                let current_data_photo = this.slides[index].dataset.photo;
                let current_data_nom = this.slides[index].dataset.nom;
                let current_data_localisation = this.slides[index].dataset.localisation;
                let current_data_vin = this.slides[index].dataset.vin;
                let current_data_ab = this.slides[index].dataset.ab;
                let current_data_hve = this.slides[index].dataset.hve;
                let current_data_video = this.slides[index].dataset.video;
                let current_data_film = this.slides[index].dataset.film;
                var descriptionDiv = document.querySelector('.vigneron-certifs');
                descriptionDiv.innerHTML = '';

                document.querySelector('.vigneron-description-text').textContent = current_data;
                document.querySelector('.vigneron-photo').classList.add('fade-out');


                // Desktop
                if (window.innerWidth > 1025) {
                    if (current_data_video) {
                        if (videoExist) {
                            var player = new Vimeo.Player('myPlayer', {
                                autoplay: false
                            });

                            function changeVideoId(newVideoId) {
                                player.loadVideo(newVideoId).then(function () {
                                    console.log('Nouvelle vidéo chargée avec succès.');
                                }).catch(function (error) {
                                    console.error('Erreur lors du chargement de la nouvelle vidéo :', error);
                                });
                            }

                            changeVideoId(current_data_video);
                        } else {
                            var player = new Vimeo.Player('myPlayer', {
                                id: current_data_video,
                                controls: false,
                                autoplay: false,
                            });
                            player.on('ended', function () {
                                // Revenir au début de la vidéo
                                player.setCurrentTime(0);
                                document.querySelector('#playButton').classList.add('active');
                            });
                            videoExist = 1;
                        }
                        document.getElementById('playButton').addEventListener('click', function () {
                            document.querySelector('#playButton').classList.remove('active');
                            player.play().then(function () {

                            }).catch(function (error) {
                                console.error('Erreur lors du démarrage de la vidéo :', error);
                            });
                        });
                        document.querySelector('#playButton').classList.add('active');
                        document.querySelector('.vigneron-photo').classList.add('inactive');
                        document.querySelector('#myPlayer').classList.remove('inactive');
                    } else {
                        document.querySelector('#playButton').classList.remove('active');
                        document.querySelector('.vigneron-photo').classList.remove('inactive');
                        document.querySelector('#myPlayer').classList.add('inactive');
                        /*var player = new Vimeo.Player('myPlayer', {
                            controls: false,
                            autoplay: false,
                        });
                        player.pause().then(function () {
                            console.log('La vidéo est en pause.');
                        }).catch(function (error) {
                            console.error('Erreur lors de la pause de la vidéo :', error);
                        });*/
                    }
                }

                // Mobile
                if (window.innerWidth < 1025) {
                    players.forEach(function (player) {
                        player.pause().then(function () {
                            console.log('La vidéo est en pause.');
                        }).catch(function (error) {
                            console.error('Erreur lors de la pause de la vidéo :', error);
                        });
                    });

                    var elements = document.querySelectorAll('#playButtonMobile');

                    if (current_data_video) {
                        var player = new Vimeo.Player(current_data_film, {
                            id: current_data_video,
                            controls: false,
                            autoplay: false
                        });
                        elements.forEach(function (element) {
                            element.classList.add('active');
                            element.addEventListener('click', function () {
                                // Démarrer la lecture lorsque le bouton est cliqué
                                player.play().then(function () {
                                    element.classList.remove('active');
                                    player.on('ended', function () {
                                        // Revenir au début de la vidéo
                                        player.setCurrentTime(0);
                                        element.classList.add('active');
                                    });
                                }).catch(function (error) {
                                    console.error('Erreur lors du démarrage de la vidéo :', error);
                                });
                            });
                        });

                        players.push(player);

                    } else {
                        elements.forEach(function (element) {
                            element.classList.remove('active');
                        });

                        var playButtonMobile = document.querySelector('#playButtonMobile');

                        if (playButtonMobile) {
                            playButtonMobile.classList.remove('active');
                        }

                    }
                }


                setTimeout(function () {
                    document.querySelector('.vigneron-photo').src = current_data_photo;
                    document.querySelector('.vigneron-photo').classList.remove('fade-out');
                }, 200);

                document.querySelector('.vigneron-nom').textContent = current_data_nom;
                document.querySelector('.vigneron-localisation').textContent = current_data_localisation;
                document.querySelector('.vigneron-vin').textContent = current_data_vin;

                if (current_data_ab == 1) {
                    var imageElement = new Image();
                    imageElement.src = '/wp-content/themes/moutoncadet/assets/img/ab.png';
                    imageElement.alt = 'Agriculture biologique';
                    descriptionDiv.appendChild(imageElement);
                }
                if (current_data_hve == 1) {
                    var imageElement = new Image();
                    imageElement.src = '/wp-content/themes/moutoncadet/assets/img/hve.png';
                    imageElement.alt = 'HVE';
                    descriptionDiv.appendChild(imageElement);
                }
            }
        }
    });
}

initSwipers2();

// Slider vins avec filtres

// Sélectionnez toutes les instances de Swiper avec la classe .swiper-vins
var swipersVins = document.querySelectorAll('.swiper-vins');

// Itérez sur chaque instance avec forEach
swipersVins.forEach(function (swiperVin) {
    new Swiper(swiperVin, {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: false,
        simulateTouch: true,
        allowTouchMove: true,
        observer: true,
        centeredSlidesBounds: false,
        speed: 800,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            // when window width is <= 499px
            768: {
                slidesPerView: 5.5,
            },
            1024: {
                slidesPerView: 7.5,
            },
        },
        on: {
            realIndexChange: function () {
                var index = this.realIndex;
                var current_data = this.slides[index].dataset.description;
                swiperVin.querySelector('.vin-description').textContent = current_data;
            }
        }
    });
});


// Swiper slider only mobile
const swiperDateDiv = document.querySelector('.swiper-date');

if (swiperDateDiv) {


    var initM = false;
    var swiperM;

    function swiperDate() {
        if (window.innerWidth <= 1024) {
            if (!initM) {
                initM = true;
                swiperM = new Swiper(".swiper-date", {
                    direction: "horizontal",
                    slidesPerView: "auto",
                    centeredSlides: true,
                    spaceBetween: 32,
                    effect: 'fade',
                    autoHeight: true,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".gutenberg-date .swiper-button-next",
                        prevEl: ".gutenberg-date .swiper-button-prev",
                        clickable: true,
                    },
                });
            }
        } else if (initM) {
            swiperM.destroy();
            initM = false;
        }
    }

    swiperDate();
    window.addEventListener("resize", swiperDate);
}

// Slider page recette

// Sélectionnez toutes les instances de Swiper avec la classe .swiper-vins
var swiperRecette = document.querySelectorAll('.swiper-single-recette');

// Itérez sur chaque instance avec forEach
swiperRecette.forEach(function (swiper) {
    new Swiper(swiper, {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        loop: false,
        simulateTouch: true,
        observer: true,
        centeredSlidesBounds: false,
        speed: 800,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".vins .swiper-pagination",
            clickable: true,
        },
        on: {
            init: function () {
                var old = document.querySelector('.end .text-link');
                var originalDiv = swiper.querySelector('.text-link');
                var container = document.querySelector('.end');
                var clonedDiv = originalDiv.cloneNode(true); // true pour cloner également les enfants
                old.remove();
                container.prepend(clonedDiv);
            },
            realIndexChange: function () {
                var index = this.realIndex;
                var old = document.querySelector('.end .text-link');
                var originalDiv = this.slides[index].querySelector('.text-link');
                var container = document.querySelector('.end');
                var clonedDiv = originalDiv.cloneNode(true); // true pour cloner également les enfants
                old.remove();
                container.prepend(clonedDiv);
            }
        }
    });
});

// Slider page accords vin --> les recettes

// Sélectionnez toutes les instances de Swiper avec la classe .swiper-vins
var swiperRecettes = document.querySelectorAll('.swiper-single-recettes');

// Itérez sur chaque instance avec forEach
swiperRecettes.forEach(function (swiper) {
    new Swiper(swiper, {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: false,
        simulateTouch: true,
        observer: true,
        centeredSlidesBounds: false,
        speed: 800,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".recette .swiper-pagination",
            clickable: true,
        },
        on: {
            init: function () {
                var old = document.querySelector('.end .text-link');
                var originalDiv = swiper.querySelector('.text-link');
                var container = document.querySelector('.end');
                var clonedDiv = originalDiv.cloneNode(true); // true pour cloner également les enfants
                old.remove();
                container.prepend(clonedDiv);
            },
            realIndexChange: function () {
                var index = this.realIndex;
                //console.log(index);
                var old = document.querySelector('.end .text-link');
                var originalDiv = this.slides[index].querySelector('.text-link');
                var container = document.querySelector('.end');
                var clonedDiv = originalDiv.cloneNode(true); // true pour cloner également les enfants
                old.remove();
                container.prepend(clonedDiv);

                document.querySelectorAll('.recette').forEach(function (element) {
                    element.classList.add('hidden');
                });
                document.querySelector('.single-recettes > #recipe > .recette-' + index).classList.remove('hidden');
            }
        }
    });
});


var swipersMets = document.querySelectorAll('.swiper-recipes');
swipersMets.forEach(function (swiper) {
    new Swiper(swiper, {
        lazy: true,
        slidesPerView: 1,
        effect: "cards",
        grabCursor: false,
        centeredSlides: false,
        observer: true,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            init: function () {
                var index = this.realIndex;

                if (index) {
                    var current_data = this.slides[index].dataset.title;
                    var current_link = this.slides[index].dataset.link;
                    var current_collection = this.slides[index].dataset.collection;
                } else {
                    var current_data = document.querySelector('.swiper-slide-active').dataset.title;
                    var current_link = document.querySelector('.swiper-slide-active').dataset.link;
                    var current_collection = document.querySelector('.swiper-slide-active').dataset.collection;
                }

                document.querySelector('.content-dynamic h2').textContent = current_data;
                document.querySelector('.heart').href = current_link;
                document.querySelector('.collection-name').textContent = current_collection;

                if (this.slides.length > 1) {
                    document.querySelector('.content-dynamic').classList.add('active');
                }

            },
            realIndexChange: function () {
                var index = this.realIndex;
                if (index) {
                    var current_data = this.slides[index].dataset.title;
                    var current_link = this.slides[index].dataset.link;
                    var current_collection = this.slides[index].dataset.collection;
                } else {
                    var current_data = this.slides[0].dataset.title;
                    var current_link = this.slides[0].dataset.link;
                    var current_collection = this.slides[0].dataset.current_collection;
                }
                document.querySelector('.content-dynamic h2').textContent = current_data;
                document.querySelector('.heart').href = current_link;
                document.querySelector('.collection-name').textContent = current_collection;
            },
            observerUpdate: function () {
                var index = this.realIndex;
                if (index) {
                    var current_data = this.slides[index].dataset.title;
                    var current_link = this.slides[index].dataset.link;
                    var current_collection = this.slides[index].dataset.collection;
                } else {
                    var current_data = this.slides[0].dataset.title;
                    var current_link = this.slides[0].dataset.link;
                    var current_collection = this.slides[0].dataset.collection;
                }

                document.querySelector('.content-dynamic h2').textContent = current_data;
                document.querySelector('.heart').href = current_link;
                document.querySelector('.collection-name').textContent = current_collection;

                // swiper.slideTo(0);
                if (this.slides.length > 1) {
                    document.querySelector('.content-dynamic').classList.add('active');
                }
            },
            click: function (event) {
                const swiperButtonPrev = event.el.querySelector('.swiper-button-prev');
                const swiperButtonNext = event.el.querySelector('.swiper-button-next');
                const clicEvent = new Event('click');
                var clickX = event.touches.currentX;
                var halfWindowWidth = window.innerWidth / 2;
                var distanceFromCenter = Math.abs(clickX - halfWindowWidth);
                const imgElement = document.querySelector('.swiper-slide-active img');
                const largeurImage = imgElement.width;

                var widthImage = largeurImage / 2;

                if (distanceFromCenter > widthImage) {
                    if (clickX < halfWindowWidth) {
                        swiperButtonPrev.dispatchEvent(clicEvent);
                    } else {
                        swiperButtonNext.dispatchEvent(clicEvent);
                    }
                }
            }
        }
    });
});


// SLIDER VIDEO (home)
/*
document.addEventListener('DOMContentLoaded', () => {
    const videoPlayers = document.querySelectorAll('iframe');
    //const videoCovers = document.querySelectorAll('.video-cover');

    // Itère sur chaque vidéo
    videoPlayers.forEach((videoPlayer, index) => {
        // Attend que la vidéo Vimeo soit chargée
        videoPlayer.addEventListener('load', () => {
            console.log("ok");
        });
    });
});
*/


// Attend que toutes les vidéos Vimeo soient chargées


// Initialise le swiper





    var timeouts = [];

    function stopAllTimeouts() {
        for (var i = 0; i < timeouts.length; i++) {
            clearTimeout(timeouts[i]);
        }
    }

    var mySwiperVideo = new Swiper('.swiper-video', {
        speed: 500,
        effect: "fade",
        allowTouchMove: false,
        on: {
            init: function () {
                var playVideo = 1;
                var index = this.realIndex;
                var activeSlide = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide-active .playerVimeo');
                var arrow = document.querySelector('.gutenberg-slider-video .arrow');
                if (activeSlide) {

                    var idVimeo = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide-active .playerVimeo').dataset.id;
                    var idVimeoContainer = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide-active .playerVimeo').dataset.vimeoc;
                    var videoDuration = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide-active .playerVimeo').dataset.duree;

                    var player = new Vimeo.Player(idVimeoContainer, {
                        id: idVimeo,
                        autoplay: true,
                        controls: false,
                        muted: true,
                        background: true,
                    });

                    player.play();


                    player.on('play', function () {
                        if (playVideo == 1) {
                            setTimeout(function () {
                                player.setCurrentTime(0);
                                player.pause();
                                mySwiperVideo.slideNext();
                            }, videoDuration * 1000);
                            playVideo = 2;
                        }

                    });


                }
                setTimeout(function () {
                    arrow.classList.add("active");
                }, 3000);
            },
            realIndexChange: function () {
                var index = this.realIndex;
                var slideActif = document.querySelector('.swiper-container .swiper-slide.count-' + index);

                // Contenu
                var progressBar = document.querySelector('.swiper-progress-bar');
                progressBar.classList.remove("animate");

                var dataTitle = slideActif.getAttribute('data-title');
                var dataCouleur = slideActif.getAttribute('data-couleur');
                var dataLink = slideActif.getAttribute('data-discover');
                var current_link = slideActif.getAttribute('data-link');
                var header = document.getElementById('header');
                var breadcrumb = document.getElementById('breadcrumb');
                var swiper = document.getElementById('swiper-video');
                var contentSlide = document.querySelector('.gutenberg-slider-video .content');
                var logoMouton = document.querySelector('.gutenberg-slider-video .logo-slider-video');

                setTimeout(function () {
                    header.className = '';
                    header.classList.add(dataCouleur);
                    swiper.className = '';
                    swiper.classList.add(dataCouleur);
                    breadcrumb.className = '';
                    breadcrumb.classList.add(dataCouleur);
                    if (index == 0) {
                        contentSlide.style.opacity = 0;
                        logoMouton.style.opacity = 0;
                    } else {
                        contentSlide.style.opacity = 1;
                        logoMouton.style.opacity = 1;
                    }
                    document.querySelector('.gutenberg-slider-video .content h2').textContent = dataTitle;
                    document.querySelector('.gutenberg-slider-video .content a').href = current_link;
                    document.querySelector('.gutenberg-slider-video .content a').textContent = dataLink;

                    // Événement click sur le lien
                    document.querySelector('.gutenberg-slider-video .content a').addEventListener("click", function (event) {
                        // Empêche l'action par défaut du lien
                        event.preventDefault();
                        var url = current_link;
                        window.location.href = url;
                    });

                }, 500);


                var progressBar = document.querySelector('.swiper-progress-bar');
                var progressBarDuration = document.querySelector('.swiper-progress-bar .slide_progress-bar span');

                var activeSlide = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide.count-' + index + ' .playerVimeo');

                if (activeSlide) {
                    var videoDuration = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide.count-' + index + ' .playerVimeo').dataset.duree;
                    var idVimeo = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide.count-' + index + ' .playerVimeo').dataset.id;
                    var idVimeoContainer = document.querySelector('.gutenberg-slider-video .swiper-container .swiper-slide.count-' + index + ' .playerVimeo').dataset.vimeoc;

                    var player = new Vimeo.Player(idVimeoContainer, {
                        id: idVimeo,
                        autoplay: false,
                        controls: false,
                        muted: true,
                        background: true,
                    });

                    player.setCurrentTime(0);
                    player.play();


                    //
                } else {
                    videoDuration = 6;
                }

                var timeout1 = setTimeout(function () {

                    if (mySwiperVideo.isEnd) {
                        mySwiperVideo.slideTo(0); // Revenir à la première diapositive
                    } else {
                        mySwiperVideo.slideNext();
                    }

                    if (activeSlide) {
                        //player.setCurrentTime(0);
                        player.pause();
                    }


                }, videoDuration * 1000);
                timeouts.push(timeout1);

                var timeout2 = setTimeout(function () {
                    videoDuration = videoDuration - 0.5;
                    progressBar.classList.add("animate");
                    progressBarDuration.style.transitionDuration = videoDuration + "s";
                }, 500);
                timeouts.push(timeout2);
            },
        }
    })
